<script setup>
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import mercadoLivreClient from 'dashboard/api/channel/mercadoLivreClient';
import Button from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();
const hasError = ref(false);
const errorMessage = ref('');
const isRequestingAuthorization = ref(false);

onMounted(() => {
  const params = new URLSearchParams(window.location.search);
  errorMessage.value = params.get('error_message') || '';
  hasError.value = Boolean(errorMessage.value);
  window.history.replaceState({}, document.title, window.location.pathname);
});

const requestAuthorization = async () => {
  isRequestingAuthorization.value = true;
  const { data } = await mercadoLivreClient.generateAuthorization();
  window.location.href = data.url;
};
</script>

<template>
  <div class="h-full w-full p-6">
    <div
      class="mx-auto flex h-full max-w-2xl flex-col items-center justify-center rounded-2xl outline outline-1 outline-n-weak px-8 py-10 text-center"
    >
      <div v-if="hasError" class="max-w-lg">
        <h5>{{ t('INBOX_MGMT.ADD.MERCADO_LIVRE.ERROR_MESSAGE') }}</h5>
        <p class="mt-3 text-sm text-n-slate-11">{{ errorMessage }}</p>
      </div>
      <template v-else>
        <h6 class="text-2xl font-medium">
          {{ t('INBOX_MGMT.ADD.MERCADO_LIVRE.CONNECT_TITLE') }}
        </h6>
        <p class="max-w-xl py-6 text-sm text-n-slate-11">
          {{ t('INBOX_MGMT.ADD.MERCADO_LIVRE.HELP') }}
        </p>
        <Button
          lg
          icon="i-lucide-store"
          :disabled="isRequestingAuthorization"
          :is-loading="isRequestingAuthorization"
          :label="t('INBOX_MGMT.ADD.MERCADO_LIVRE.CONNECT_BUTTON')"
          @click="requestAuthorization"
        />
      </template>
    </div>
  </div>
</template>
